<template>
    <div class="modal-overlay">
        <div
            v-click-outside="closeModal"
            class="modal"
            :style="styles"
        >
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        styles: {
            type: Object,
            default: () => {},
        },
    },

    mounted() {
        document.body.style.overflow = 'hidden'
    },

    unmounted() {
        document.body.style.removeProperty('overflow')
    },

    methods: {
        closeModal($event) {
            this.$emit('close', $event)
        },
    },
}
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    z-index: 5000;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(33, 38, 40, 0.4);
}

.modal {
    position: absolute;
    width: 412px;
    background-color: #212628;
    color: #ffffff;
    font-size: 18px;
    font-family: 'Avenir Book';
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}
</style>
